import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();



// WEBPACK FOOTER //
// ./src/_helpers/history.js